import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { fr } from './content/fr';
import { es } from './content/es';
import { en } from './content/en';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage content={fr} data-id="element-3" />} data-id="element-2" />
        <Route path="/es" element={<LandingPage content={es} data-id="element-5" />} data-id="element-4" />
        <Route path="/en" element={<LandingPage content={en} data-id="element-7" />} data-id="element-6" />
        <Route path="*" element={<LandingPage content={fr} data-id="element-9" />} data-id="element-8" />
      </Routes>
    </BrowserRouter>;
}